import React from "react";
import HologramHero from "../components/HologramHero";
import Icon from "../components/Icon";
import { IMAGES } from "../data/content";
import { useI18n } from "../i18n/LanguageContext";

const withBreaks = (lines = []) =>
  lines.map((l, i) => (
    <React.Fragment key={i}>
      {l}
      {i < lines.length - 1 && <br />}
    </React.Fragment>
  ));

const GALLERY = ['Arbeitstisch_1','Aufbau','Aufbau_Kunde','Bauleitung','Diagnose','Montage_1','Schwerdrehmaschine','Wartung','Werkstatt'];

export default function Ueber() {
  const { t } = useI18n();
  const u = t.ueber;

  return (
    <div data-testid="page-ueber">
      <HologramHero
        label={u.hero.label}
        image={IMAGES.heroUeber}
        title={withBreaks(u.hero.titleLines)}
        subtitle={u.hero.subtitle}
        paragraphs={u.hero.paragraphs}
        badges={u.hero.badges}
        cards={u.hero.cards}
      />

      {/* Text block */}
      <section className="py-16 bg-white" data-testid="ueber-intro">
        <div className="max-w-[900px] mx-auto px-5 lg:px-8 text-center">
          {u.intro.map((p, i) => (
            <p
              key={i}
              className={`text-lg md:text-xl text-ink-soft leading-relaxed ${i < u.intro.length - 1 ? "mb-6" : ""}`}
              style={{ color: "var(--ink-soft)" }}
            >
              {p}
            </p>
          ))}
        </div>
      </section>

      {/* Strengths */}
      <section className="py-12 section-soft" data-testid="ueber-strengths">
        <div className="max-w-[1320px] mx-auto px-5 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-x-6 gap-y-10">
            {u.strengths.map((s) => (
              <div key={s.title}>
                <Icon name={s.icon} size={32} className="text-blue-brand mb-4" strokeWidth={1.5} />
                <h3 className="font-head font-bold text-ink text-[14px] uppercase tracking-wide mb-2">{s.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-white" data-testid="ueber-values">
        <div className="max-w-[1320px] mx-auto px-5 lg:px-8">
          <p className="text-center text-blue-brand font-head font-bold uppercase tracking-[0.18em] text-sm mb-2">{u.valuesLabel}</p>
          <h2 className="text-center font-head font-extrabold text-ink text-3xl md:text-4xl mb-14">{u.valuesTitle}</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-x-6 gap-y-10">
            {u.values.map((v) => (
              <div key={v.title} className="text-center sm:text-left">
                <Icon name={v.icon} size={34} className="text-blue-brand mb-4 mx-auto sm:mx-0" strokeWidth={1.5} />
                <h3 className="font-head font-bold text-ink text-[14px] uppercase tracking-wide mb-2">{v.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Anspruch + team images */}
      <section className="py-16 section-soft" data-testid="ueber-anspruch">
        <div className="max-w-[1320px] mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-10 items-center">
          <div className="bg-blue-50/60 rounded-2xl p-8 lg:p-10">
            <div className="flex items-center gap-3 mb-5">
              <Icon name="Rocket" size={30} className="text-blue-brand" strokeWidth={1.5} />
              <span className="font-head font-bold text-ink uppercase tracking-wide text-sm">{u.anspruch.label}</span>
            </div>
            <p className="handwrite text-3xl md:text-4xl text-ink leading-snug">
              {u.anspruch.text}
            </p>
            <div className="w-40 h-1 mt-6 rounded-full timeline-line" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <img src={IMAGES.inbetriebnahme} alt="Roboterzelle" className="rounded-xl h-40 w-full object-cover" />
            <img src={IMAGES.engineersTablet} alt="Ingenieure" className="rounded-xl h-40 w-full object-cover" />
            <img src={IMAGES.serviceWartung} alt="Service" className="rounded-xl h-40 w-full object-cover" />
            <img src={IMAGES.teamCoils} alt="Team" className="rounded-xl h-40 w-full object-cover" />
          </div>
        </div>
      </section>

      <section className="py-16 bg-white" data-testid="ueber-gallery">
        <div className="max-w-[1320px] mx-auto px-5 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
            {GALLERY.map((name) => (
              <img key={name} src={`/gallery/${name}.jpg`} alt={name} loading="lazy" className="rounded-xl h-40 md:h-44 w-full object-cover shadow-sm hover:shadow-md transition-shadow" />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
